import { store } from '../stores/store'

/**
 * The resolved landingpage-mapping `documentId` from the referer / `SVID` match,
 * or `null` when there is no match. Attached to app-internal linkouts and
 * qr-code urls as `refID` so the branch mapping survives the handoff.
 */
export function getResolvedRefDocumentId(): string | null {
    const id = store.entryReferrerLandingMatch?.mapping?.documentId?.trim()
    return id ? id : null
}


// attach the resolved landingpage-mapping documentId to url
export function applyRefIdSearchParam(
    url: URL,
    refDocumentId?: string | null,
): void {
    const ref = (
        refDocumentId === undefined ? getResolvedRefDocumentId() : refDocumentId
    )?.trim()
    if (ref) {
        url.searchParams.set('refID', ref)
    }
}

// Return `rawUrl` with the resolved `refID` search param appended
export function appendRefIdToUrl(
    rawUrl: string,
    refDocumentId?: string | null,
): string {
    try {
        const url = new URL(rawUrl)
        applyRefIdSearchParam(url, refDocumentId)
        return url.toString()
    } catch {
        return rawUrl
    }
}
